import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { X } from 'lucide-react-native';
import { useTheme, SPACING, TYPOGRAPHY } from '../../theme';

interface PanelHeaderProps {
  title: string;
  onClose: () => void;
  /** nativeID for the title, so a DockedPanel's `ariaLabelledBy` (or a
   *  region's own aria-labelledby) can point at it. */
  headingId?: string;
  testID?: string;
  closeLabel?: string;
}

/**
 * Pinned title + close row for a right-docked panel (panel-system.md review,
 * notes 4/11): the post panel had this already; add-property and the
 * property panel reuse it instead of growing their own copies. Meant to sit
 * above a `DockedPanel`'s `scroll={false}` body — this row itself never
 * scrolls.
 */
export function PanelHeader({
  title,
  onClose,
  headingId,
  testID = 'panel-header-close',
  closeLabel = 'Close',
}: PanelHeaderProps) {
  const { colors } = useTheme();
  return (
    <View style={styles.header}>
      <Text nativeID={headingId} style={[styles.title, { color: colors.text }]} numberOfLines={1}>
        {title}
      </Text>
      <TouchableOpacity
        onPress={onClose}
        testID={testID}
        accessibilityRole="button"
        accessibilityLabel={closeLabel}
        aria-label={closeLabel}
        hitSlop={8}>
        <X size={20} color={colors.textSecondary} />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: SPACING.sm,
    paddingHorizontal: SPACING.md,
    paddingVertical: SPACING.sm,
  },
  title: {
    ...TYPOGRAPHY.h4,
    flex: 1,
  },
});
